import React from "react";
import { CloseButtonProps } from "react-toastify";
import { UnstyledButton } from "@sportal/cdk/unstyledButton/UnstyledButton";

import { useIntlTranslate } from "../../hooks";
import { Icon } from "../icon/Icon";

import "./CloseButton.scss";

export const CloseButton = ({ closeToast }: CloseButtonProps) => {
  const translate = useIntlTranslate();

  return (
    <UnstyledButton
      className="notification__close-icon notification__icon--button"
      onClick={closeToast}
      aria-label={translate("aria_close")}
    >
      <Icon icon="fa-regular fa-times" />
    </UnstyledButton>
  );
};
